var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumbsDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6432 15.4171L13.1177 19.3989C12.0301 19.367 11.123 18.5895 10.9872 17.5605L10.4779 13.7007L10.3853 13L3.53627 13C2.95968 13 2.55237 12.465 2.73474 11.947L5.44709 4.2409C5.79196 3.26088 6.76038 2.59985 7.85119 2.59985L14.5453 2.59985L18.0869 3.94147L18.0869 12.3438L16.3334 12.6759C14.9073 12.9461 13.8237 14.0502 13.6433 15.4168L13.6432 15.4171ZM19.0152 13.8L16.6645 14.2452C15.9516 14.3803 15.4097 14.9323 15.3196 15.6157L14.7852 19.6641C14.6845 20.4273 13.9995 21 13.1874 21C11.2172 21 9.55503 19.6105 9.31069 17.7589L8.89379 14.6L3.53628 14.6C1.80647 14.6 0.58499 12.9952 1.13199 11.441L3.8442 3.73499C4.41909 2.10176 6.03315 0.999998 7.8512 0.999999L14.8707 0.999999L15.0217 1.05714L19.0943 2.6L24 2.6L24 13.8L19.0152 13.8ZM19.7762 12.2L22.3104 12.2L22.3104 4.19999L19.7762 4.19999L19.7762 12.2Z",
    fillOpacity: 0.4,
    stroke: "white",
    strokeWidth: 0.25
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDown);
export default __webpack_public_path__ + "static/media/thumbs-down.36218259.svg";
export { ForwardRef as ReactComponent };